import {Button} from "@mui/material";
import {RTL} from "../../cache/CacheRtl";
import {colors, borders} from "./colors";

const SecondaryButton = ({children, startIcon, onClick, disabled, size, sx, ...rest}) => {
  const isSmall = size === "small";

  return (
      <RTL>
        <Button
            variant="outlined"
            startIcon={startIcon}
            onClick={onClick}
            disabled={disabled}
            sx={{
              backgroundColor: colors.bg,
              color: colors.textSecondary,
              borderColor: colors.border,
              height: isSmall ? "36px" : "44px",
              fontSize: isSmall ? "13px" : "14px",
              fontWeight: 600,
              padding: isSmall ? "6px 12px" : "6px 20px",
              borderRadius: borders.radius.md,
              textTransform: "none",
              "&:hover": {
                borderColor: colors.borderHover,
                backgroundColor: colors.bg,
              },
              "&:disabled": {
                borderColor: colors.border,
                color: colors.borderHover,
              },
              "& .MuiButton-startIcon": {
                marginRight: "-4px",
                marginTop: "2px",
                marginLeft: "8px",
              },
              ...sx,
            }}
            {...rest}
        >
          {children}
        </Button>
      </RTL>
  );
};

export default SecondaryButton;
